<template>
  <div class="">
    <h3>Team breakdown</h3>
    <lw-table
      v-if="estimate.showRedFlags"
      :type="'lined table--lined--foreground'"
      :class="['table--mobile', estimate.showRedFlags ? 'flags' : '']"
      :headings="[
        'Person',
        'Low ' + rateUnit[estimate.rateType].label + 's',
        'Target ' + rateUnit[estimate.rateType].label + 's',
        'High ' + rateUnit[estimate.rateType].label + 's',
        'Low price',
        'Target price',
        'High price'
      ]"
      :alignment="[
        'left',
        'right',
        'right',
        'right',
        'right',
        'right',
        'right'
      ]"
    >
      <tr
        v-for="(person, index) in estimate.team"
        :key="index">
        <td>{{ person.name }}</td>
        <td
          class="align-right"
          data-label="Low time">{{ person.lowTime | round2 }}</td>
        <td
          class="align-right"
          data-label="Target time">{{ person.midTime | round }}</td>
        <td
          class="align-right"
          data-label="High time">{{ person.highTime | round2 }}</td>
        <td
          class="align-right"
          data-label="Low price">{{ person.lowPrice | currency }}</td>
        <td
          class="align-right"
          data-label="Target price">{{ person.midPrice | currency }}</td>
        <td
          class="align-right"
          data-label="High price">{{ person.highPrice | currency }}</td>
      </tr>
      <tr>
        <td class="bold">Sub-total:</td>
        <td class="bold align-right"/>
        <td class="bold align-right"/>
        <td class="bold align-right"/>
        <td
          class="bold align-right"
          data-label="Low price">{{ estimate.lowPrice / estimate.projectManagement | currency }}</td>
        <td
          class="bold align-right"
          data-label="Target price">{{ estimate.midPrice / estimate.projectManagement | currency }}</td>
        <td
          class="bold align-right"
          data-label="High price">{{ estimate.highPrice / estimate.projectManagement | currency }}</td>
      </tr>
      <tr>
        <td class="bold">Buffer ({{ (estimate.projectManagement - 1) * 100 | round }}%)</td>
        <td class="bold align-right"/>
        <td class="bold align-right"/>
        <td class="bold align-right"/>
        <td
          class="bold align-right"
          data-label="Low price">{{ estimate.lowPrice - (estimate.lowPrice / estimate.projectManagement) | currency }}</td>
        <td
          class="bold align-right"
          data-label="Target price">{{ estimate.midPrice - (estimate.midPrice / estimate.projectManagement) | currency }}</td>
        <td
          class="bold align-right"
          data-label="High price">{{ estimate.highPrice - (estimate.highPrice / estimate.projectManagement) | currency }}</td>
      </tr>
      <tr>
        <td class="bold">Total:</td>
        <td
          class="bold align-right accent-text"
          data-label="Low">{{ estimate.lowTime | round2 }}</td>
        <td
          class="bold align-right accent-text"
          data-label="Mid">{{ estimate.midTime | round }}</td>
        <td
          class="bold align-right accent-text"
          data-label="High">{{ estimate.highTime | round2 }}</td>
        <td
          class="bold align-right accent-text"
          data-label="Low price">{{ estimate.lowPrice | currency }}</td>
        <td
          class="bold align-right accent-text"
          data-label="Target price">{{ estimate.midPrice | currency }}</td>
        <td
          class="bold align-right accent-text"
          data-label="High price">{{ estimate.highPrice | currency }}</td>
      </tr>
    </lw-table>
    <lw-table
      v-else
      :type="'lined table--lined--foreground'"
      :class="'table--mobile'"
      :headings="[
        'Person',
        'Low ' + rateUnit[estimate.rateType].label + 's',
        'High ' + rateUnit[estimate.rateType].label + 's',
        'Low price',
        'High price'
      ]"
      :alignment="[
        'left',
        'right',
        'right',
        'right',
        'right'
      ]"
    >
      <tr
        v-for="(person, index) in estimate.team"
        :key="index">
        <td>{{ person.name }}</td>
        <td
          class="align-right"
          data-label="Low">{{ person.lowTime | round2 }}</td>
        <td
          class="align-right"
          data-label="High">{{ person.highTime | round2 }}</td>
        <td
          class="align-right"
          data-label="Low price">{{ person.lowPrice | currency }}</td>
        <td
          class="align-right"
          data-label="High price">{{ person.highPrice | currency }}</td>
      </tr>
      <tr>
        <td class="bold">Sub-total:</td>
        <td class="bold align-right"/>
        <td class="bold align-right"/>
        <td
          class="bold align-right"
          data-label="Low price">{{ estimate.lowPrice / estimate.projectManagement | currency }}</td>
        <td
          class="bold align-right"
          data-label="High price">{{ estimate.highPrice / estimate.projectManagement | currency }}</td>
      </tr>
      <tr>
        <td class="bold">Buffer ({{ (estimate.projectManagement - 1) * 100 | round }}%)</td>
        <td class="bold align-right"/>
        <td class="bold align-right"/>
        <td
          class="bold align-right"
          data-label="Low price">{{ estimate.lowPrice - (estimate.lowPrice / estimate.projectManagement) | currency }}</td>
        <td
          class="bold align-right"
          data-label="High price">{{ estimate.highPrice - (estimate.highPrice / estimate.projectManagement) | currency }}</td>
      </tr>
      <tr>
        <td class="bold">Total:</td>
        <td
          class="bold align-right accent-text"
          data-label="Low">{{ estimate.lowTime }}</td>
        <td
          class="bold align-right accent-text"
          data-label="High">{{ estimate.highTime }}</td>
        <td
          class="bold align-right accent-text"
          data-label="Low price">{{ estimate.lowPrice | currency }}</td>
        <td
          class="bold align-right accent-text"
          data-label="High price">{{ estimate.highPrice | currency }}</td>
      </tr>
    </lw-table>
  </div>
</template>

<script>
import Table from '../livewires/Table'

export default {
  components: {
    lwTable: Table
  },
  props: {
    page: {
      type: String,
      default: ''
    }
  },
  computed: {
    estimate () {
      return this.$store.getters.estimate(this.page)
    },
    rateUnit () {
      return this.$store.getters.rateUnits(this.estimate.rateCard)
    }
  }
}
</script>

<style scoped>
  div {
    overflow: auto;
  }
  @media screen and (max-width: 48em) {
    td {
      padding-right: calc(var(--line) / 2);
      width: 33%;
    }
    .flags tbody tr {
      grid-template-columns: 1fr 1fr 1fr;
    }
    .flags tbody td:first-child {
      grid-column: span 3;
    }
    td:first-child {
      clear: both;
      float: none;
      margin-bottom: 0;
      margin-top: calc(var(--line) / 2);
      width: 100%;
      font-weight: var(--semibold);
      font-family: var(--wide);
    }
  }
</style>
